// BootstrapVue 모달 관련 화면 스크롤 락 failsafe 유틸
//
// b-modal이 정상 hide 이벤트를 발생시키지 않고 사라지는 경우(예: 부모 컴포넌트의
// v-if 조건 변경으로 인한 강제 언마운트) body의 'modal-open' 클래스와
// padding-right/overflow 인라인 스타일이 잔존하여 페이지 스크롤이 잠긴 상태로 남는
// 문제가 있다. 이 유틸은 그런 경우를 대비한 안전망이며, 다른 모달이 여전히
// 떠있는지 확인 후에만 스크롤 락을 해제한다.

/**
 * 다른 활성 모달이 없을 때만 body의 스크롤 락을 해제한다.
 * Vue 컴포넌트의 onModalHidden / beforeDestroy 등에서 호출.
 *
 * 호출자가 Vue 컴포넌트 인스턴스인 경우 nextTick 기반으로 호출해도 안전하지만,
 * 컴포넌트 소멸 시점이라 nextTick을 거는 것이 위험할 수 있어 이 함수는 동기로
 * 즉시 정리한다. 필요 시 호출자가 nextTick으로 감싼다.
 */
export function releaseBodyScrollLockIfStandalone() {
  if (typeof document === 'undefined') return;
  if (document.querySelector('.modal.show')) return;
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('padding-right');
  document.body.style.removeProperty('overflow');
}
